import request from "@/utils/oms-request";
import download from "@/utils/oms-download";
import qs from "qs";
// 供应商采购订单
export const getList = (params: any) =>
  request({
    url: "/purchase-order/supplier",
    method: "get",
    params
  });

//下载
export const downloadList = (params: any) =>
  download({
    responseType: "blob",
    url: `/purchase-order/supplier/download`,
    method: "get",
    params
  });
// 采购订单管理-列表查询
export const getPoList = (params: any) =>
  request({
    url: "/purchase-order/po-list/search",
    method: "get",
    params
  });
// 采购订单管理-下载
export const downloadPoList = (params: any) =>
  download({
    responseType: "blob",
    url: `/purchase-order/po-list/download`,
    method: "get",
    params
  });

// 采购订单状态
export const getOrderStatus = () =>
  request({
    url: "/purchase-order/order-status",
    method: "get"
  });

// 采购订单审核状态
export const getReviewStatus = () =>
    request({
        url: "/purchase-order/review-status",
        method: "get"
    })

// 采购订单管理-查看详情
export const getPoDetail = (data: any) =>
  request({
    url: `/purchase-order/search/detail`,
    method: "post",
    data
  });
// 采购订单详情-下载
export const downloadPoDetail = (id: string) =>
  download({
    responseType: "blob",
    url: `/purchase-order/${id}/infos/excel`,
    method: "get"
  });
export const downloadTemplate = (id: string) =>
  download({
    responseType: "blob",
    url: `/purchase-order/${id}/template`,
    method: "get"
  });

export const batchDownloadDetailContract = (data: any) =>
    download({
        responseType: "blob",
        url: `/purchase-order/detail-contract/batch`,
        method: "post",
        data
    });

export const batchDownloadContract = (data: any) =>
    download({
        responseType: "blob",
        url: `/purchase-order/contract/batch`,
        method: "post",
        data
    });

  export const downloadTemplateExcel = (id: string) =>
  download({
    responseType: "blob",
    url: `/purchase-order/${id}/template/excel`,
    method: "get"
  });

//审核通过
export const auditPass = (id: string) =>
  request({
    url: `/purchase-order/${id}`,
    method: "put"
  });
// 挂起
export const suspend = (id: string, params: any) =>
  request({
    url: `/purchase-order/${id}/suspend`,
    method: "put",
    params
  });
// 备注
export const remarkPo = (data: any) =>
  request({
    url: `/purchase-order/remark`,
    method: "put",
    data
  });


// 供应商采购订单-备注
export const remark = (id: string, data: any) =>
  request({
    url: `/purchase-order/supplier/${id}/remark`,
    method: "put",
    data
  });
// 付款已交期维护查询
export const getPayment = (id: string, params: any) =>
  request({
    url: `/purchase-order/${id}/payment`,
    method: "get",
    params
  });
//收款款已交期维护
export const payment = (id: string, data: any) =>
  request({
    url: `/purchase-order/${id}/payment`,
    method: "put",
    data
  });
//  付款已交期维护-付款方式
export const getPaymentMethod = () =>
  request({
    url: `/purchase-order/po-payment-method`,
    method: "get"
  });
//重置金额
export const resetAmount = (packingListId: string) =>
  request({
    url: `/purchase-order/${packingListId}/reset-amount`,
    method: "put"
  });
export const updateAmount = (groupInfoId: string, params: any) =>
  request({
    url: `/purchase-order/${groupInfoId}/amount`,
    method: "put",
    params
  });
//查看修改的型号
export const getUpdateModel = (params: any) =>
  request({
    url: `/purchase-order/update-model`,
    method: "get",
    params
  });
// 修改型号
export const updateModel = (type: any, data: any) =>
  request({
    url: `/purchase-order/update-model?type=${type}`,
    method: "put",
    data
  });
//型号类型
export const getModelType = () =>
  request({
    url: `/purchase-order/update-model/types`,
    method: "put"
  });
// 交货校验-头部信息
export const getHeaderInfo = (packingListId: string) =>
  request({
    url: `/purchase-order/${packingListId}/header-info`,
    method: "get"
  });
// 交货校验列表 /purchase-order/delivery-verification/list
export const getDeliveryVerificationList = (params: any) =>
  request({
    url: `/purchase-order/delivery-verification/list`,
    method: "get",
    params
  });
// 装箱单产品重新匹配 /purchase-order/re-match-packing-list
export const reMatchPackingList = (data: any) =>
  request({
    url: `/purchase-order/re-match-packing-list`,
    method: "post",
    data
  });
//查询某个供应商下未核销的采购订单
export const getNoWrittenOff = (params: any) =>
  request({
    url: `/purchase-order/no-written-off`,
    method: "get",
    params
  });
// 匹配
export const matchPackingList = (params: any) =>
  request({
    url: `/purchase-order/match-packing-list`,
    method: "get",
    params
  });
export const getReMatchPackingList = (data: any) =>
  request({
    url: `/purchase-order/re-match-packing-list`,
    method: "post",
    data
  });

export const writeOff = (id: string, params: any) =>
  request({
    url: `/purchase-order/${id}/write-off`,
    method: "get",
    params
  });
//查看超欠发列表
export const getOrderOverdue = (id: string) =>
  request({
    url: `/purchase-order/${id}/overdue`,
    method: "get",
  });
// 采购订单出货备注
export const poShippingRemark = (id: string, data: any) =>
  request({
    url: `/purchase-order/${id}/po-shipping-remark`,
    method: "put",
    data
  });
// 查询装箱单下采购订单的供应商
export const getSuppliers = (params: any) =>
  request({
    url: `/purchase-order/suppliers`,
    method: "get",
    params
  });

  // /purchase-order/{packingListId}/copy-delivery-amount
// 复制下单金额
export const cloneOrderMoney = (packingListId: any) =>
  request({
    url: `/purchase-order/${packingListId}/copy-delivery-amount`,
    method: "put",
  });

  // 终止订单
export const postCancelOrder = (id) =>
  request({
    url: `/purchase-order/${id}/cancel-order`,
    method: "post"
  });

  // 终止订单列表
export const getCancelOrderList = (id) =>
  request({
    url: `/purchase-order/${id}/cancel-order-list`,
    method: "get"
  });

  // /purchase-order/update-to-po-model
  // 更新型号为PO中的号码
export const updateToPoModel = (params) =>
  request({
    url: `/purchase-order/update-to-po-model`,
    method: "put",
    params
  });

  // /purchase-order/{id}/cancel-invalid 取消作废
  export const putCancelInvalid = (id) =>
  request({
    url: `/purchase-order/${id}/cancel-invalid `,
    method: "put"
  });
  // /purchase-order/{id}/update-packing-or-accessories-state 交货完成
  export const updatePackingState = (id) =>
  request({
    url: `/purchase-order/${id}/update-packing-or-accessories-state`,
    method: "put"
  });

  // /purchase-order/packing-list/{id}/delete-by-re-upload
  export const deleteByReUpload = (id) =>
  request({
    url: `/purchase-order/packing-list/${id}/delete-by-re-upload`,
    method: "delete"
  });

  // /purchase-order/{id}/appendix
  // 判断是否为重新上传回执
  export const getAppendix = (id,params) =>
  request({
    url: `/purchase-order/${id}/appendix`,
    method: "get",
    params
  });

  // /purchase-order/make-underdelivery // 标记欠发 PUT
  export const putMakeUnderdelivery = (data) =>
  request({
    url: `/purchase-order/make-underdelivery`,
    method: "put",
    data
  });
  // /purchase-order/delivery-verification/can-save
  // 调用接口参数查询是否可以保存/创建
  export const getCanSave = (params) =>
  request({
    url: `/purchase-order/delivery-verification/can-save`,
    method: "get",
    params
  });

  // /purchase-order/info/unit-price
  export const putUnitPrice = (data) =>
  request({
    url: `/purchase-order/info/unit-price`,
    method: "put",
    data
  });

  // /purchase-order/{infoId}/shipping-remark

  export const poDetailShippingRemark = (id: string, data: any) =>
  request({
    url: `/purchase-order/${id}/shipping-remark`,
    method: "put",
    data
  });

  // /purchase-order/{infoId}/remark
  export const poDetailRemark = (id: string, data: any) =>
  request({
    url: `/purchase-order/${id}/remark`,
    method: "put",
    data
  });

  // /purchase-order/{id}/write-off
  // 采购订单财务核销确认
  export const poWriteOff = (id: string) =>
  request({
    url: `/purchase-order/${id}/write-off`,
    method: "put"
  });

  // /purchase-order/supplier/{supplierId}/amount
  export const getAmounte = (supplierId) =>
    request({
      url: `/purchase-order/supplier/${supplierId}/amount`,
      method: "get"
    });

    // /purchase-order/{id}/cancel-review
    export const getCancelReview = (id) =>
      request({
        url: `/purchase-order/${id}/cancel-review`,
        method: "put"
      });
    // /purchase-order/{id}/cancel-suspend
    export const getCancelSuspend = (id) =>
      request({
        url: `/purchase-order/${id}/cancel-suspend`,
        method: "put"
      });

  // /purchase-order/{id}/abnormal 标记异常
  export const markException = (id) =>
    request({
      url: `/purchase-order/${id}/abnormal`,
      method: "put"
    });
  // /purchase-order/{id}/normal  标记正常
  export const markNormal = (id) =>
    request({
      url: `/purchase-order/${id}/normal`,
      method: "put"
    });
   // /purchase-order/company-discount-price  更新公司定价
  export const updateCompanyDiscountPrice = (data: any) =>
    request({
      url: `/purchase-order/company-discount-price`,
      method: "put",
      data
    });

  // 获取采购订单品牌
  export const queryBrands = (params) =>
      request({
          url: `/purchase-order/brands`,
          method: "get",
          params
      });

  export const batchAssignMark = (data) =>
      request({
          url: `/purchase-order/mark`,
          method: "post",
          data,
      })

// 获取采购订单的唛头字母
  export const queryMarkLetter = (poCodes:string[],customerId:string) =>
      request({
          url: `/purchase-order/mark-letters`,
          method: "get",
          params:{
            poCodes:poCodes,
            customerId:customerId
          }
      });

  export const updateContractualDeliveryDate = (params) =>
      request({
          url: `/purchase-order/contractualDeliveryDate`,
          method: "put",
          params,
      });

  export const queryPayments = (params) =>
      request({
          url: `/purchase-order/payments`,
          method: "get",
          params,
      });

  export const updatePayments = (data) =>
      request({
          url: `/purchase-order/payments`,
          method: "put",
          data,
      });

export const batchDownloadDetail = (data) =>
download({
    responseType: "blob",
    url: `/purchase-order/download-po-details`,
    method: "post",
    data
});

export const updateCompanyPriceRemark = (id: string, data: any) =>
    request({
        url: `/purchase-order/info/${id}/company-discount-price-remark`,
        method: "put",
        data
    });


  // 采购订单费用详情
  export const queryOtherFeeList = (params) =>
      request({
          url: `/purchase-order-other-fee/list`,
          method: "get",
          params
      });

  // 采购订单添加费用
  export const createOtherFee = (params) =>
      request({
          url: `/purchase-order-other-fee`,
          method: "put",
          params
      });

  export const deleteOtherFee = (params) =>
      request({
          url: `/purchase-order-other-fee`,
          method: "delete",
          params
      });

  export const queryDistributionList = (params) =>
      request({
          url: `/purchase-order-other-fee/distribute`,
          method: "get",
          params
      });

  export const updateDistributionList = (data) =>
      request({
          url: `/purchase-order-other-fee/distribute`,
          method: "post",
          data
      });

  export const deleteDistribution = (params) =>
      request({
          url: `/purchase-order-other-fee/distribute`,
          method: "delete",
          params
      });

  export const queryPoDelayDelivery = (data) =>
      request({
          url: `/purchase-order/overdue`,
          method: "post",
          data
      });

  // 采购订单交期跟踪页面的列表查询
  export const queryPoDeliveryTrack = (params) =>
      request({
          url: `/purchase-order/search/delivery-track`,
          method: "get",
          params,
          paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" })
      });
  export const getPIDeliveryData = (params) =>
      request({
          url: `/purchase-order/pi-delivery-data`,
          method: "get",
          params
      });